import script from "./AddTeamMember.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTeamMember.vue?vue&type=script&setup=true&lang=js"

import "./AddTeamMember.vue?vue&type=style&index=0&id=2d998096&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d998096"]])

export default __exports__